import {getVersion, runElectronFunc} from "./comm";
import {openExternalLink} from "./window";
import {n2v} from "../Often";
import {inputPopupQueue} from '../../components/popup-queue/index.js'

const download = (props) => {
    if(window.ElectronDownloadApi) runElectronFunc('ElectronDownloadApi', 'fileDownload', props)
    else fn_fileDownloadForElectron(props.url, '_blank')
}

const multiFileDownloads = (props) => {
    if(window.ElectronDownloadApi) runElectronFunc('ElectronDownloadApi', 'multiFileDownloads', props)
    else fn_fileDownloadForElectron(props.url, '_blank')
}

const selectDownloadPath = (props) => {
    if(window.ElectronDownloadApi) runElectronFunc('ElectronDownloadApi', 'selectDownloadPath', props)
}

const autoUpdate = (props) => {
    if (window.ElectronDownloadApi) runElectronFunc('ElectronDownloadApi', 'autoUpdate', props)
    else autoUpdateOnForElectron();
}
const checkFlowNewVersion = () => {
    Company.drawServiceBlock(BLOCK_TYPE.STOP_FLOWNEW, function () {
        DownloadApp.desktopDownloadDirect();
        window.close();
    }, '');
    $("#tempPopup").addClass("serviceStop");
}
const checkFlowVersion = async () => {
    const pckNm = getPckNm();
    const userOs = userOsCheck();
    const downloadData = {PCK_NM: pckNm, GB: userOs};
    const data = await Ajax.executeApi('FLOW_UPDATE_R001', downloadData);
    const result = data.flow_rec?.[0];
    if(!result) return;
    const { MINI_VER: miniVer, SELECT_VER: selectVer, LINK_URL: linkUrl } = result;
    await checkVersionAndMakePopup({userOs, miniVer, selectVer, linkUrl});
}

const checkVersionAndMakePopup = async (props = {}) => {
    if(!window.ElectronProcessApi) return;
    const { userOs = DownloadApp.userOsCheck(), miniVer, selectVer, linkUrl } = props;
    const electronVersion = n2v(window.ElectronProcessApi?.getVersion(), '3_1_1');
    const currentVerWithComma = electronVersion.replace(/[^0-9|_]/g, '').replace(/_/g, '.').trim();

    const isBetaVersion = electronVersion.includes('beta');
    const needMinimumUpdate = Often.electronIsSmallerThanInputVersion({ inputVersion: miniVer.replace(/\./g, '_').replace(/[^0-9_]/g, '') });
    const isSmallerThanSelectVer = Often.electronIsSmallerThanInputVersion({ inputVersion: selectVer.replace(/\./g, '_').replace(/[^0-9_]/g, '') });

    const isUnderSelectVer = !needMinimumUpdate && isSmallerThanSelectVer;
    const releaseOnly = !Often.isServerModeByHost("REAL") && (electronVersion === '2_5_1');

    if (!needMinimumUpdate && !isUnderSelectVer && !isBetaVersion && !releaseOnly) return;

    const helpLinkUrl = getHelpLinkUrl(userOs === 'WINDOWS');
    let contentsInfo = needMinimumUpdate || releaseOnly ? BLOCK_TYPE.DESKTOP_FORCE_UPDATE : BLOCK_TYPE.DESKTOP_SELECT_UPDATE;

    if (ServerChecker.isKyowon) contentsInfo = BLOCK_TYPE.KYWON_DESKTOP_UPDATE;

    const versionInfo =  i18next.t(electron.versionReleased) + '\n' +
                                i18next.t(electron.updateRequire) + '\n' +
                                i18next.t(electron.currentVersion) + ` &#58; Ver ${currentVerWithComma} \n` +
                                i18next.t(electron.latestVersion) + ` &#58; Ver ${releaseOnly? '2.5.2' : selectVer}`

    contentsInfo.main = versionInfo;

    if (ServerChecker.isSamsungLife) {
        contentsInfo.title = '업데이트';
        contentsInfo.main = `새로운 버전이 출시됐습니다.\n가젯에서 “온라인 성장 놀이터”를 검색 후\n최신버전(${updateRec.flow_rec[0].SELECT_VER.trim()})으로 설치해주세요.`;
        contentsInfo.submit = '';
        Company.drawServiceBlock(contentsInfo, '', '', '');
    }

    if (Often.isFunc("POPUP_QUEUE")) {
        inputPopupQueue(".temp-popup", 20, async () => {
            await Company.drawServiceBlock(contentsInfo, () => download({url: linkUrl}), '', helpLinkUrl);
        });
    } else {
        await Company.drawServiceBlock(contentsInfo, () => download({url: linkUrl}), '', helpLinkUrl);
    }
}


const getHelpLinkUrl = (isWindows) => {
    let helpLinkUrl = '';
    if(Often.isGlobal()){
        let flowLang = Often.null2Void(Often.getCookie("FLOW_LANG"), 'en_uk');
        switch (flowLang) {
            case "ja" :
                helpLinkUrl = "https://support.morningmate.com/ja/articles/7206161";
                break;
            default :
                helpLinkUrl = "https://support.morningmate.com/en/articles/7206161";
        }
    } else {
        helpLinkUrl = isWindows? 'https://support.flow.team/ko/flow/4408449610265' : 'https://support.flow.team/ko/flow/360038630092';
    }
    return helpLinkUrl;
}

const checkForUpdateManually = (props={}) => {
    if (window.ElectronDownloadApi) runElectronFunc('ElectronDownloadApi', 'checkForUpdatesManual', props)
    else return;
}

function userOsCheck() {
    var os = "";
    var ua = navigator.userAgent;

    if (ua.indexOf("Macintosh") > -1) {
        os = "OS_X";
    } else if (ua.indexOf("Linux") > -1) {
        os = "LINUX";
    } else {
        os = "WINDOWS";
    }
    return os;
}

const getPckNm =() => {
    let pckNm = 'team.flow.flowMiniRenewal' //default
    if(Often.isFunc(Func.CLOUD.SECURE_CONNECT) || Often.isFunc("MINI_SECURE_DOWNLOAD")) pckNm = "secure.team.flow.flowMiniRenewal";
    if(Often.isFunc(Func.CLOUD.MINI_DIRECTORY_DOWNLOAD)) pckNm = "dir.team.flow.flowMiniRenewal";
    if(Often.null2Void(_ENTER_YN, "N") === "Y") pckNm = "team.flow.flowEntMini";
    if(Often.isGlobal()) pckNm = "com.morningmate.flowMiniRenewal";
    return pckNm;
}



export {
    download,
    autoUpdate,
    checkFlowVersion,
    checkFlowNewVersion,
    checkForUpdateManually,
    multiFileDownloads,
    selectDownloadPath,
};
